import { render } from "./ErrorBox.vue?vue&type=template&id=2c92231b"
import script from "./ErrorBox.vue?vue&type=script&lang=js"
export * from "./ErrorBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kribesk/Documents/Sources/server/homie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__